import {ThemeProvider} from '@emotion/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {RecoilRoot} from 'recoil';
import App from './App';
import {light} from './emotion/theme';
import './i18n/i18n';
import GlobalStyles from './style/GlobalStyles';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <ThemeProvider theme={light}>
            <GlobalStyles/>
            <RecoilRoot>
                <BrowserRouter>
                    <App/>
                </BrowserRouter>
            </RecoilRoot>
        </ThemeProvider>
    </React.StrictMode>
);
